import {useContext} from 'react'
import {DynamicTable} from '../../../../components/DynamicTable'
import {SALES_REP_REPORT_COLUMNS} from '../../utils'
import SalesRepReportTableRow from './SalesRepReportTableRow'
import {SalesRepReportContext} from '../../context'

const SalesRepReportTable = () => {
  const {salesRepData, isLoading, onSortingChange, filters} = useContext(SalesRepReportContext)

  return (
    <DynamicTable
      id='sales-rep-report-table'
      data={salesRepData}
      sortableColumns={SALES_REP_REPORT_COLUMNS}
      TableRow={SalesRepReportTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
      noDataMessage='No sales rep data found'
      permissionPath='inquires'
    />
  )
}

export default SalesRepReportTable
